import React from 'react'
import VideoToggle from './VideoToggle'
import PropTypes from 'prop-types'
import VideoPlayer from '../../videoPlayer/VideoPlayer'

class VideoPreviewWrapper extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      videoShowing: false
    }

    this.handleOnClick = this.handleOnClick.bind(this)
  }

  handleOnClick () {
    this.setState(prevState => {
      return {
        videoShowing: !prevState.videoShowing
      }
    })
  }

  renderVideo () {
    if (this.state.videoShowing) {
      return (
        <div className='admin-preview-video'>
          <VideoPlayer video={this.props.video} asyncFacebook />
        </div>
      )
    }
  }

  render () {
    return (
      <div className='video-preview-wrapper'>
        <VideoToggle
          label={this.props.label}
          video={this.props.video}
          handleClick={this.handleOnClick}
          durationInTitle={this.props.durationInTitle}
        />
        {this.renderVideo()}
      </div>
    )
  }
}

VideoPreviewWrapper.defaultProps = {
  durationInTitle: true
}

VideoPreviewWrapper.propTypes = {
  durationInTitle: PropTypes.bool,
  label: PropTypes.string,
  video: PropTypes.object
}

export default VideoPreviewWrapper
